<template>
  <div>
    <h2>Choose a treatment:</h2>
    <app-choose-treatment :categoryId="categoryId"></app-choose-treatment>
  </div>
</template>

<script>
import ChooseTreatment from "@/components/BookingApp/UserView/Menu/ChooseTreatment";
export default {
  name: "ChooseATreatment",
  data: () => {
    return {
      categoryId: null,
    };
  },
  components: {
    appChooseTreatment: ChooseTreatment,
  },
  //TODO take the ctegory id from route params and pass it as prop
  watch: {
    $route(to, from) {
      this.categoryId = this.$route.params.id;
      console.warn("VIEW categoryId", this.categoryId, to, from);
    },
  },
  created: function () {
    this.categoryId = this.$route.params.id;
    console.log(
      "Choose A Treatment was created, categoryId = ",
      this.categoryId
    );
  },
};
</script>

<style>
</style>